import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var _excluded = ["children", "onClick"];
var ModalTrigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.cloneElement(children, Object.assign({
    ref: ref,
    onClick: onClick
  }, props));
});

export { ModalTrigger as default };
//# sourceMappingURL=ModalTrigger.js.map
